"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchService = void 0;
const BASE_URL = 'https://datapi.jup.ag';
class SearchService {
    constructor() {
        this.ROUTE = {
            SEARCH: `${BASE_URL}/v1/assets`,
        };
    }
    search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.ROUTE.SEARCH}/search?query=${query}`, {
                credentials: 'include',
            });
            const data = yield response.json();
            return data;
        });
    }
}
exports.searchService = new SearchService();
